import React from 'react'
import { CaseStatus } from 'share/domain/caseStatus'
import { Orientation } from 'share/domain/enums'
import classNames from 'classnames'
import './styles.scss'

interface PhaseStatusProps {
  orientation: Orientation
  statusList: CaseStatus[] | undefined | null
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}

const PhaseStatus = (props: PhaseStatusProps): JSX.Element => {
  let statusList: CaseStatus[]
  if (!props.statusList) {
    return <></>
  } else {
    statusList = props.statusList
  }

  const isHorizontal = props.orientation === Orientation.horizontal
  let orientationClass = 'ui-phases'
  let containerClass = 'container-horizontal'

  if (!isHorizontal) {
    orientationClass = 'ui-phases-vertical'
    containerClass = 'container-vertical'
  }

  const renderIcon = (
    status: CaseStatus,
    isFirst: boolean,
    isLast: boolean,
    completed: boolean,
    index: number
  ): JSX.Element => {
    const phaseClass = classNames({
      phase: true,
      completed: completed,
      current: status.current
    })

    const phaseIconClass = classNames({
      mdi: true,
      'mdi-file-document-box-search-outline': isFirst && !isLast,
      'mdi-gavel': !isFirst && !isLast,
      'mdi-check-circle-outline': isLast && !isFirst
    })

    const nextIconClass = classNames({
      mdi: true,
      'mdi-chevron-right': isHorizontal,
      'mdi-chevron-down': !isHorizontal,
      'ui-phases-next-icon': true
    })

    return (
      <div className='phase-wrapper' onClick={props.onClick}>
        <div className={phaseClass} key={index}>
          <span className={phaseIconClass} />
          {!isLast && status.current && completed && (
            <span className={nextIconClass} />
          )}
        </div>
      </div>
    )
  }

  const renderText = (
    status: CaseStatus,
    completed: boolean,
    index: number
  ): JSX.Element => {
    const phaseClass = classNames({
      'phase-text': true,
      completed: completed,
      current: status.current
    })

    return (
      <div className={phaseClass} key={index}>
        {isHorizontal ? (
          <span onClick={props.onClick}>{status.name}</span>
        ) : (
          <h3>{status.name}</h3>
        )}
        {!isHorizontal && status.description}
      </div>
    )
  }

  const currentPhaseIndex = statusList.findIndex((item) => item.current)

  return (
    <React.Fragment>
      <div className={containerClass}>
        <div className={orientationClass}>
          {statusList.map((status, index) => {
            const isFirst = index === 0
            const isLast = index === statusList.length - 1
            // All indexes lower than the current are completed
            const completed = index <= currentPhaseIndex
            return (
              <div className='wrapper' key={status.name}>
                {renderIcon(status, isFirst, isLast, completed, index)}
                {renderText(status, completed, index)}
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default PhaseStatus
